import type { OsobyFyzickaOsobaDto } from '@gov-nx/api';
import type { Nullable } from '@gov-nx/core/types';
import type { FormData } from './context.types';

interface GetCleanedChangedValuesParams {
	changedValues: FormData;
	data: Nullable<OsobyFyzickaOsobaDto>;
}

export const getCleanedChangedValues = ({
	changedValues,
	data,
}: GetCleanedChangedValuesParams): FormData => {
	let filteredChangedValues: FormData = {};

	Object.entries(changedValues).forEach(([ogKey, value]) => {
		const key = ogKey as keyof FormData;

		switch (key) {
			case '_useEmail':
			case 'email':
			case '_usePhone':
			case 'phone':
				filteredChangedValues = {
					...filteredChangedValues,
					[key]: value,
				};
				break;
			case 'omezeniSvepravnosti':
				if (
					(!data?.omezeniSvepravnosti && value === 'ne') ||
					(data?.omezeniSvepravnosti && value === 'ano')
				) {
					return undefined;
				}
				filteredChangedValues = {
					...filteredChangedValues,
					[key]: value,
				};
				break;

			case 'adresaDorucovaci':
			case 'adresaPobytu':
				if (value === data?.[key]?.adresaText) {
					return undefined;
				}
				filteredChangedValues = {
					...filteredChangedValues,
					[key]: value,
				};
				break;
			default:
				if (typeof value === 'string') {
					if (
						value.toLowerCase() ===
						(data?.[key as keyof Nullable<OsobyFyzickaOsobaDto>] ?? '')
							.toString()
							.toLowerCase()
					) {
						return undefined;
					}
				}

				filteredChangedValues = {
					...filteredChangedValues,
					[key as keyof FormData]: value,
				};
				break;
		}
	});

	if (!filteredChangedValues.newPlaceOfBirth && filteredChangedValues.stat) {
		const { stat, ...rest } = filteredChangedValues;
		filteredChangedValues = rest;
	}

	return filteredChangedValues;
};
